





import Vue from 'vue'
import Home from '../components/Home.vue'

export default Vue.extend({
  components: {
    Home
  },
  created: function(){
      this.$store.state.showTopNavigation = true;
  }
  
})
